export default __webpack_public_path__ + "static/media/algarrobina.1feeae5a.jpeg";